module.exports = __webpack_public_path__ + "static/media/marker-medium.b2d7fde6.svg";